export const minDesktop = 640;
